import FixtureLabel from "@atgof-common/FixtureLabel";
import dayjs from "dayjs";
import { useMemo } from "react";
import { View } from "react-native";
import DayPicker from "./DayPicker";
import { IconButton } from "react-native-paper";

export function DateEditor({
  label,
  value,
  onChange,
}: {
  label: string;
  value: Date | undefined;
  onChange: (v: Date | undefined) => void;
}) {
  const day = useMemo(
    () => (value ? dayjs(value) : undefined),
    [value?.getTime()],
  );
  return (
    <View style={{ flexDirection: "row" }}>
      <View style={{ alignSelf: "center" }}>
        <FixtureLabel text={label} />
        {day ? (
          <DayPicker day={day} setDay={(d) => onChange(d.toDate())} />
        ) : null}
      </View>
      <IconButton
        style={{ alignSelf: "flex-end" }}
        icon={day ? "calendar-remove" : "calendar-plus"}
        onPress={() => onChange(day ? undefined : new Date())}
      />
    </View>
  );
}
